import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="week-calendar"
export default class extends Controller {
  static targets = ["headerRow", "label"]

  connect() {
    this.currentDate = new Date()
    this.currentDate = this.startOfWeek(this.currentDate)
    this.render()
  }

  prev() {
    this.shiftWeek(-7)
  }

  next() {
    this.shiftWeek(7)
  }

  today() {
    this.currentDate = this.startOfWeek(new Date())
    this.render()
  }

  shiftWeek(days) {
    this.currentDate.setDate(this.currentDate.getDate() + days)
    this.render()
  }

  render() {
    this.renderHeader()
    this.renderLabel()
    this.renderBodyDates()
  }

  renderHeader() {
    this.headerRowTarget.innerHTML = `<th class="site-col">現場／作業</th>`

    for (let i = 0; i < 7; i++) {
      const date = new Date(this.currentDate)
      date.setDate(this.currentDate.getDate() + i)

      const th = document.createElement("th")

      th.dataset.date = this.toISODate(date)

      th.innerHTML = `
        <div class="d1">${this.formatDate(date)}</div>
        <div class="d2">${this.dayOfWeek(date)}</div>`

      this.headerRowTarget.appendChild(th)
    }
  }

    renderLabel() {
    const start = new Date(this.currentDate)
    const end = new Date(this.currentDate)
    end.setDate(start.getDate() + 6)

    this.labelTarget.textContent = `${start.getFullYear()}年 ${this.formatRange(start, end)}`
  }

  renderBodyDates() {
    const dates = [...this.headerRowTarget.querySelectorAll("th")]
        .slice(1)
        .map(th => th.dataset.date)

    document.querySelectorAll("#scheduleBody tr").forEach(tr => {
      tr.querySelectorAll("td:not(.site-col)").forEach((td, index) => {
        td.dataset.date = dates[index]
      })
    })
  }


  startOfWeek(date) {
    const d = new Date(date)
    const day = d.getDay() || 7
    d.setDate(d.getDate() - (day - 1))
    d.setHours(0, 0, 0, 0)
    return d
  }

  formatDate(date) {
    return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
        date.getDate()
    ).padStart(2, "0")}`
  }

  formatRange(start, end) {
    return `${this.formatDate(start)}〜${this.formatDate(end)}`
  }

  dayOfWeek(date) {
    return ["(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)"][date.getDay()]
  }

  toISODate(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }

}
